export enum AccountType {
  FAMILY_MEMBER = 'FamilyMember',
  EMPLOYEE = 'Employee',
}

export const LOCAL_STORAGE_FROM_AGENCY_SET_PASSWORD_PAGE = "LOCAL_STORAGE_FROM_AGENCY_SET_PASSWORD_PAGE";